<template>
  <div class="card vue-avatar-cropper-demo text-center" id="image-cropper" v-if="new_cropper == true">
    <vs-avatar
      v-if="image_url != null"
      class="border-2 border-solid border-grey con-vs-avatar text-6xl pick-avatar rounded-item"
      size="120px"
      :src="image_url"
    ></vs-avatar>
    <vs-avatar
      v-else
      class="border-2 border-solid border-grey con-vs-avatar text-6xl pick-avatar rounded-item"
      size="120px"
      :src="null"
    ></vs-avatar>
    <div class="flex justify-center" style="height: 30px;">
      <div style="transform: translateY(-40px);" v-if="message == 'uploading'">
        <img src="../../assets/images/loading.svg" />
      </div>
      <div v-else-if="message == 'completed' && image_url != null" class="flex align-center text-success text-sm">
        <feather-icon icon="CheckIcon" svgClasses="h-6 w-6 stroke-current text-success mr-2" />Upload success
      </div>
    </div>
    <avatar-cropper
      @uploading="handleUploading"
      @completed="handleCompleted"
      :upload-headers="headers"
      trigger=".pick-avatar"
      :labels="labels"
      :upload-url="domain + '/v1/orderonline/item/form/upload'"
    />
    <div class="flex justify-center">
      <vs-button
        type="border"
        color="danger"
        class="btn-upload"
        @click="confirmDeleteAvatar"
        v-if="image_url"
      >
        <feather-icon icon="TrashIcon" svgClasses="h-4 w-4 stroke-current" />Delete Image
      </vs-button>
    </div>
  </div>
</template>

<script>
import AvatarCropper from "vue-avatar-cropper";
import { StringHelper } from "../../models/string_helper";
import { domain } from "../../axios";

export default {
  components: { AvatarCropper },
  name: "image-uploader",
  props: {
    item: {
      type: Object,
      default: Object
      // required: true
    },
    isVariant: {
      type: Boolean
    }
  },
  created() {
    this.message = "ready";
  },
  data() {
    return {
      message: "ready",
      labels: { submit: "Submit", cancel: "Cancel" },
      StringHelper,
      uploaded: false,
      image_url:
        this.item !== undefined && this.item.image != null && this.item.image != 'deleted'
          ? this.item.image
          : null,
      domain: domain,
      new_cropper: false
    };
  },
  watch: {
    item: {
      immediate: true,
      deep: true,
      handler() {
        // If you are using cropper in a modal, you should initialize the cropper after the modal shown completely. Otherwise, you will not get a correct cropper.
        this.new_cropper= false;
        setTimeout(() => {
          this.new_cropper = true;
        }, 200)
      }
    },
  },
  methods: {
    // eslint-disable-next-line
    handleUploading(form, xhr) {
      this.message = "uploading";
    },
    // handleUploaded(response) {
    //   if (response.status == "success") {
    //     this.user.avatar = response.url;
    //     // Maybe you need call vuex action to
    //     // update user avatar, for example:
    //     // this.$dispatch('updateUser', {avatar: response.url})
    //     this.message = "user avatar updated.";
    //   }
    // },
    // eslint-disable-next-line
    handleCompleted(response, form, xhr) {
      this.message = "completed";
      this.uploaded = true;
      this.image_url = response[0].url;
      this.$emit("uploaded-done", {
        image_url: this.image_url,
        delete_image_url: response[0].delete_url
      });
    },
    // handlerError(message, type, xhr) {
    //   // console.log(message);
    //   // this.message = "Oops! Something went wrong...";
    // },
    confirmDeleteAvatar() {
      this.$vs.dialog({
        type: "confirm",
        title: "Confirmation",
        text: "Are you sure to delete this image?",
        accept: this.deleteAvatar
      });
    },
    deleteAvatar() {
      this.image_url = null;
      this.uploaded = false;
      this.$vs.notify({
        title: "Success",
        text: "Delete image success!",
        color: "success",
        position: "top-right"
      });
      this.$emit("uploaded-done", {
        image_url: "deleted",
        delete_image_url: "deleted"
      });
    }
  },
  computed: {
    headers() {
      return {
        Authorization: "Bearer " + localStorage.getItem("accessToken"),
        "G-ClientID": localStorage.getItem("domainId")
      };
    }
  }
};
</script>